import { NgFor, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { CategoryProduct } from 'src/app/interfaces/category-product';
import { StarArrayPipe } from 'src/app/pipes/star-array.pipe';
import { CategoryProductService } from 'src/app/service/category-product.service';
import { environment } from 'src/environments/environment.prod';
import { SanitizeHtmlPipe } from "../../../../../pipes/dabsanitizeHtml.pipe";
import { CommunicationService } from 'src/app/service/communication.service';
import { CartService } from 'src/app/service/cart.service';
import { FormsModule } from '@angular/forms';
import { CategoryProductFilter } from 'src/app/interfaces/category-product-filter';

@Component({
  standalone: true,
  selector: 'app-category-product',
  templateUrl: './category-product.component.html',
  styleUrls: ['./category-product.component.css'],
  imports: [NgFor, RouterLink, NgIf, NgClass, StarArrayPipe, SanitizeHtmlPipe, FormsModule]
})

export class CategoryProductComponent {

  selectedPriceRanges: string[] = [];

  allData: any;
  filterData: any;
  categoryData: any;
  subCategoryData: any;
  total_products: any;
  productDetailsData: any;
  imagePath = environment.cdnImagePath;
  product_keys: any;
  category_key: number = 0;
  category_name: string = "";
  product_key: number = 0;
  product_name: string = "";
  offset: number = 0;
  limit: number = 30;
  sort_by: string = "";
  all_category_products: boolean = false;
  show_categories: boolean = true;
  brand_keys: string[] = [];
  size_keys: string[] = [];
  color_keys: string[] = [];
  feature_keys: string[] = [];
  price_ranges: string = "";

  averageTotal: any;
  totalAverageOutOf5: number = null;
  reviewsCount: number = null;

  isFilterDataFetched: boolean = false;

  isOpenMake: boolean = true;
  isOpenModel: boolean = true;
  isOpenBrand: boolean = true;
  isOpenColor: boolean = true;
  isOpenSize: boolean = true;
  isOpenFeature: boolean = true;
  isOpenPrice: boolean = true;

  brandData: any;
  colorData: any;
  sizeData: any;
  featureData: any;

  order_key: number = null;
  orderQuantity: { [key: string]: number } = {};
  addToCartButtons: { [key: string]: boolean } = {};
  @Input() disableCheckoutButton: boolean = false;
  @Output() disdisableCheckoutButtonEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private categoryProductService: CategoryProductService,
    private router: Router,
    public dialog: MatDialog,
    private cartService: CartService,
    private comm: CommunicationService
  ) { }

  ngOnInit(): void {
    this.category_key = +localStorage.getItem('selectedcategorykey');
    this.getCategoryProductData();
    this.orderQuantity = JSON.parse(localStorage.getItem('orderQuantity')) || {};
    this.addToCartButtons = JSON.parse(localStorage.getItem('addToCartButtons')) || {};
  }

  updatePriceRange(event: Event, value: string): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedPriceRanges.push(value);
    } else {
      this.selectedPriceRanges = this.selectedPriceRanges.filter(range => range !== value);
    }
    this.price_ranges = this.selectedPriceRanges.join(',');
    this.getCategoryProductData();
  }

  onFeatureChange(featureId: string, event: any) {
    if (event.target.checked) {
      if (!this.feature_keys.includes(featureId)) {
        this.feature_keys.push(featureId);
      }
    } else {
      this.feature_keys = this.feature_keys.filter(id => id !== featureId);
    }
    this.getCategoryProductData();
  }

  onColorChange(colorId: string, event: any) {
    if (event.target.checked) {
      if (!this.color_keys.includes(colorId)) {
        this.color_keys.push(colorId);
      }
    } else {
      this.color_keys = this.color_keys.filter(id => id !== colorId);
    }
    this.getCategoryProductData();
  }

  onSizeChange(sizeId: string, event: any) {
    if (event.target.checked) {
      if (!this.size_keys.includes(sizeId)) {
        this.size_keys.push(sizeId);
      }
    } else {
      this.size_keys = this.size_keys.filter(id => id !== sizeId);
    }
    this.getCategoryProductData();
  }

  onBrandChange(brandId: string, event: any) {
    if (event.target.checked) {
      if (!this.brand_keys.includes(brandId)) {
        this.brand_keys.push(brandId);
      }
    } else {
      this.brand_keys = this.brand_keys.filter(id => id !== brandId);
    }
    this.getCategoryProductData();
  }

  getCategoryProductData(): void {
    const data: CategoryProduct = {
      category_key: this.category_key,
      category_name: this.category_name,
      product_key: this.product_key,
      product_name: this.product_name,
      offset: this.offset,
      limit: this.limit,
      sort_by: this.sort_by,
      all_category_products: this.all_category_products,
      show_categories: this.show_categories,
      size_keys: this.size_keys.length > 0 ? this.size_keys.join(",") : "",
      color_keys: this.color_keys.length > 0 ? this.color_keys.join(",") : "",
      brand_keys: this.brand_keys.length > 0 ? this.brand_keys.join(",") : "",
      price_ranges: this.price_ranges,
      feature_keys: this.feature_keys.length > 0 ? this.feature_keys.join(",") : ""
    };
    this.categoryProductService.categoryProductList(data).subscribe({
      next: (response: any) => {
        this.allData = response[0].data;
        this.categoryData = response[0].data.category;
        this.subCategoryData = response[0].data.sub_categories;
        this.total_products = response[0].data.total_products[0].total_products;
        this.product_keys = response[0].data.total_products[0].product_keys;
        this.productDetailsData = response[0].data.product_details;
        if (!this.isFilterDataFetched) {
          this.isFilterDataFetched = true;
          this.getCategoryProductFilterData();
        }
        this.productDetailsData.forEach(product => {
          this.initializeQuantity(product.product_variation_key);
        });
      }
    });
  }

  getCategoryProductFilterData(): void {
    const data: CategoryProductFilter = {
      product_keys: this.product_keys,
      total_products: this.total_products
    };
    this.categoryProductService.categoryProductFilterList(data).subscribe({
      next: (response: any) => {
        this.filterData = response[0].data;
        this.brandData = Object.entries(response[0].data?.brands[0]).map(([id, name]) => ({
          id: id,
          name: name
        }));
        this.colorData = Object.entries(response[0].data?.colors[0]).map(([id, name]) => ({
          id: id,
          name: name
        }));
        this.sizeData = Object.entries(response[0].data?.sizes[0]).map(([id, name]) => ({
          id: id,
          name: name
        }));
        this.featureData = Object.entries(response[0].data?.features[0]).map(([id, name]) => ({
          id: id,
          name: name
        }));
      }
    });
  }

  updateLimit(newLimit: number): void {
    this.offset = 0;
    this.limit = newLimit;
    this.getCategoryProductData();
  }

  updateSorting(event: any): void {
    this.sort_by = event.target.value;
    this.getCategoryProductData();
  }

  subCategoriesRedirection(event: CategoryProduct): void {
    this.category_key = event.category_key;
    this.category_name = event.category_name.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '-');;
    localStorage.setItem('selectedcategorykey', String(event.category_key));
    this.router.navigate(['/' + this.category_name, 'c' + this.category_key]);
  }

  productRedirection(event: CategoryProduct): void {
    this.product_key = event.product_key;
    this.product_name = event.product_name.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '-');
    this.router.navigate(['/' + this.product_name, 'p' + this.product_key]);
  }

  getTeotalAverageOutOf5(totalAverageOutOf5: number) {
    this.totalAverageOutOf5 = totalAverageOutOf5;
  }

  getTotalReviewsCount(count: number) {
    this.reviewsCount = count;
  }

  loadMoreProduct(): void {
    this.offset += this.limit;
    this.categoryProductService.categoryProductList({
      category_key: this.category_key,
      category_name: this.category_name,
      product_key: this.product_key,
      product_name: this.product_name,
      offset: this.offset,
      limit: this.limit,
      sort_by: this.sort_by,
      all_category_products: this.all_category_products,
      show_categories: this.show_categories,
      size_keys: this.size_keys.length > 0 ? this.size_keys.join(",") : "",
      color_keys: this.color_keys.length > 0 ? this.color_keys.join(",") : "",
      brand_keys: this.brand_keys.length > 0 ? this.brand_keys.join(",") : "",
      price_ranges: this.price_ranges,
      feature_keys: this.feature_keys.length > 0 ? this.feature_keys.join(",") : ""
    }).subscribe({
      next: (response: any) => {
        if (response[0]?.data?.product_details?.length) {
          this.productDetailsData = [...this.productDetailsData, ...response[0].data.product_details];
          this.productDetailsData.forEach(product => {
            this.initializeQuantity(product.product_variation_key);
          });
        }
      }
    });
  }

  initializeQuantity(productKey: string): void {
    if (!this.orderQuantity[productKey]) {
      this.orderQuantity[productKey] = 1;
    }
  }

  increaseQuantity(productKey: string): void {
    if (!this.orderQuantity[productKey]) {
      this.orderQuantity[productKey] = 1;
    }
    this.orderQuantity[productKey]++;
  }

  decreaseQuantity(productKey: string): void {
    if (this.orderQuantity[productKey] && this.orderQuantity[productKey] > 1) {
      this.orderQuantity[productKey]--;
    }
  }

  async onAddToCart(product: any) {
    try {
      this.order_key = +localStorage.getItem('orderId') || null;
      this.initializeQuantity(product.product_variation_key);
      this.addToCartButtons[product.product_variation_key] = true;
      this.disableCheckoutButton = true;
      this.disdisableCheckoutButtonEvent.emit(this.disableCheckoutButton);
      localStorage.setItem('ItemRecentlyAdded', 'true');
      localStorage.setItem('orderQuantity', JSON.stringify(this.orderQuantity));
      localStorage.setItem('addToCartButtons', JSON.stringify(this.addToCartButtons));
      await this.cartService.addToCart(
        product,
        this.order_key,
        this.orderQuantity[product.product_variation_key],
        product.price,
        product.promotion_key,
        false,
        '',
        false
      );
      this.comm.itemCount.next(null);
      this.disableCheckoutButton = false;
      this.disdisableCheckoutButtonEvent.emit(this.disableCheckoutButton);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      this.disableCheckoutButton = false;
      this.disdisableCheckoutButtonEvent.emit(this.disableCheckoutButton);
    }
  }

  onCheckout(): void {
    this.router.navigate(['/cart']);
  }

  togglePanelMake() {
    this.isOpenMake = !this.isOpenMake;
  }

  togglePanelModel() {
    this.isOpenModel = !this.isOpenModel;
  }

  togglePanelBrand() {
    this.isOpenBrand = !this.isOpenBrand;
  }

  togglePanelSize() {
    this.isOpenSize = !this.isOpenSize;
  }

  togglePanelColor() {
    this.isOpenColor = !this.isOpenColor;
  }

  togglePanelFeature() {
    this.isOpenFeature = !this.isOpenFeature;
  }

  togglePanelPrice() {
    this.isOpenPrice = !this.isOpenPrice;
  }

  redirectAndScroll(product: any, sectionId: string) {
    this.productRedirection(product);
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 1000);
  }
}